export default "__VITE_ASSET__EwGV6RpV__"